import ProtectedImage from "./ProtectedImg";

function Visionaries() {
  const coFounders = [
    {
      name: "Darshan Gupta",
      title: "Founder & CEO",
      image:
        "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751637441/darshan-gupta-web_q4mmyn.png",
      role: "Oversees operations, strategy, and sales.",
      background:
        "With a strong background in real estate, he brings domain-specific insight to align product with market needs.",
    },
    {
      name: "Jay Bajaj",
      title: "Co-founder & Tech Manager",
      image:
        "https://res.cloudinary.com/dcpgwly0i/image/upload/v1751637442/jay-bajaj-web_vizffb.png",
      role: "Leads the tech team, and backend systems.",
      background:
        "Having worked on large-scale backend platforms, he ensures the product scales reliably and securely.",
    },
  ];

  return (
    <section className="max-w-6xl mx-auto px-8 py-10 lg:mt-8">
      <h2 className="text-2xl font-bold text-center">The Founders</h2>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-10 mt-10">
        {coFounders.map((person, index) => (
          <div
            key={index}
            className="flex flex-col items-center text-center bg-[#FAF9F6] p-6 rounded-xl shadow-md"
          >
            <ProtectedImage
              src={person.image}
              alt={person.name}
              className="w-48 h-48" // Tailwind sizing / styling
              imgClass="rounded-full object-cover shadow"
            />
            {/* <img
              src={person.image}
              alt={person.name}
              className="w-32 h-32 rounded-full object-cover shadow"
            /> */}
            <h3 className="text-xl font-semibold text-gray-900 pt-4 pb-1">
              {person.name}
            </h3>
            <p className="text-sm text-[#dc9209] font-medium mb-2">
              {person.title}
            </p>
            <p className="text-gray-800 text-sm py-1">{person.role}</p>
            <p className="text-gray-500 text-sm">{person.background}</p>
          </div>
        ))}
      </div>
    </section>
  );
}

export default Visionaries;
